/*
* Salla Offer Modal Component: popup modal to display the offers
* You can use these classes to target the elements in the component.
*/

.s-offer-modal {
  &-body {
    
  }
  &-badge {
    &-icon {

    }
    &-text {

    }
  }
  &-product {
    &-image-wrap {

    }
    &-image {

    }
    &-info {

    }
    &-name {

    }
    &-price {

    }
    &-old-price {

    }
  }
  &-btn-wrap {

  }
  &-footer {

  }
  &-expiry {

  }
  &-remember-label {

  }
  &-remember-input {

  }
  &-scrolled-slider-wrap {

  }
  &-slider-nav {

  }
  &-nav-btn {

  }
  &-nav-btn-icon {

  }
  &-next-btn {
    
  }
  &-prev-btn {
    
  }
  &-btn-is-active {

  }
}